import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";



const menuData = [
  {
    section: "DASHBOARDS",
    items: [
      {
        name: "Dashboards",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="7" height="7" rx="1" />
            <rect x="14" y="3" width="7" height="7" rx="1" />
            <rect x="3" y="14" width="7" height="7" rx="1" />
            <rect x="14" y="14" width="7" height="7" rx="1" />
          </svg>
        ),
        hasDropdown: false,
        path: "/dashboard"
      },
    ],
  },
  {
    section: "APPS",
    items: [
      {
        name: "Users",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        ),
        path: "/Dashboard/Userstable"
      },
      {
        name: "Restaurants",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
        ),
        path: "/Dashboard/Restaurant"
      },
      {
        name: "Riders",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="5" cy="10" r="3" />
            <path d="M8 10h8" />
            <circle cx="19" cy="10" r="3" />
            <path d="M5 13v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4" />
            <line x1="12" y1="10" x2="12" y2="13" />
          </svg>
        ),
        hasDropdown: false,
        path: "/Dashboard/Drivers"
      },
      // {
      //   name: "Payments",
      //   icon: (
      //     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      //       <rect x="2" y="6" width="20" height="12" rx="2" />
      //       <line x1="2" y1="10" x2="22" y2="10" />
      //       <circle cx="18" cy="14" r="1" />
      //     </svg>
      //   ),
      //   hasDropdown: false,
      //   path: "/Dashboard/Payment"
      // },
      {
        name: "Orders",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="9" cy="21" r="1" />
            <circle cx="20" cy="21" r="1" />
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
          </svg>
        ),
        hasDropdown: false,
        path: "/Dashboard/orders"
      },
      // {
      //   name: "Coupons",
      //   icon: (
      //     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      //       <path d="M3 9v6a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9M7 12h10M7 15h10" />
      //       <circle cx="7" cy="12" r="1" />
      //       <circle cx="17" cy="12" r="1" />
      //     </svg>
      //   ),
      //   hasDropdown: false,
      //   path: "/Dashboard/Coupons"
      // },
    ],
  },
  {
    section: "PAYMENTS",
    items: [
      {
        name: "Withdrawal",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2v20M2 12h20" />
            <path d="M12 7l5 5m-10 0l5-5m0 10l5 5m-10 0l5-5" />
          </svg>
        ),
        hasDropdown: false,
        path: "/Dashboard/Withdrawals"
      },
      {
        name: "Invoices",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="8" y1="13" x2="16" y2="13" />
            <line x1="8" y1="17" x2="16" y2="17" />
            <line x1="8" y1="9" x2="16" y2="9" />
          </svg>
        ),
        hasDropdown: false,
        path: "/Dashboard/Invoices"
      },
    ],
  },
  {
    section: "DISHES",
    items: [
      {
        name: "Menu",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="8" y1="6" x2="21" y2="6" />
            <line x1="8" y1="12" x2="21" y2="12" />
            <line x1="8" y1="18" x2="21" y2="18" />
            <line x1="3" y1="6" x2="3.01" y2="6" />
            <line x1="3" y1="12" x2="3.01" y2="12" />
            <line x1="3" y1="18" x2="3.01" y2="18" />
          </svg>
        ),
        hasDropdown: false,
        path: "/Dashboard/Menu"
      },
    ],
  },
  {
    section: "Settings",
    items: [
      {
        name: "Regions",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
            <line x1="2" y1="12" x2="22" y2="12" />
          </svg>
        ),
        path: "/Dashboard/Regions"
      },
      {
        name: "Staff",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        ),
        path: "/Dashboard/StaffTable"
      },
      {
        name: "Roles",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
          </svg>
        ),
        path: "/Dashboard/RolesPermissions"
      },
      {
        name: "General",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3m0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
          </svg>
        ),
        path: "/Dashboard/GeneralSettings"
      },
    ]
  },
  {
    section: "Reports",
    items: [
      {
        name: "Reports",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="2" x2="12" y2="22" />
            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
          </svg>
        ),
        path: "/Dashboard/Reports"
      },
    ]
  },
  {
    section: "App SUPPORT",
    items: [
      {
        name: "Map",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
        ),
        path: "/Dashboard/MapDashboard"
      },
      {
        name: "Support",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            <circle cx="9" cy="10" r="1" />
            <circle cx="12" cy="10" r="1" />
            <circle cx="15" cy="10" r="1" />
          </svg>
        ),
        path: "/Dashboard/Support"
      },
      // {
      //   name: "Admin",
      //   icon: (
      //     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      //       <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      //     </svg>
      //   ),
      //   path: "/Dashboard/Admin"
      // },
      {
        name: "AppSettings",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
          </svg>
        ),
        path: "/Dashboard/AppSettings"
      },
        {
        name: "App Banners",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="3" width="20" height="14" rx="2" />
            <line x1="2" y1="10" x2="22" y2="10" />
          </svg>
        ),
        path: "/Dashboard/AppBanners"
      },
       {
        name: "Locations",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
        ),
        path: "/Dashboard/Locations"
      },
      {
        name: "Tickets",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="12" y1="11" x2="12" y2="17" />
            <line x1="9" y1="14" x2="15" y2="14" />
          </svg>
        ),
        path: "/Dashboard/tickets"
      },
      {
        name: "Notifications",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
          </svg>
        ),
        path: "/Dashboard/Notification"
      },
      {
        name: "Send Notifications",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 2L11 13" />
            <path d="M22 2l-7 20-4-9-9-4 20-7z" />
          </svg>
        ),
        path: "/Dashboard/sendnotifications"
      },
      {
        name: "Live Status",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        ),
        path: "/Dashboard/livestatus"
      },
           
            {
        name: "FAQ",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        ),
        path: "/Dashboard/faq"
      }
    ]
  },
  
  {
    section: "Config",
    items: [
      {
        name: "Delivery Fare",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="9" cy="21" r="1" />
            <circle cx="20" cy="21" r="1" />
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
            <line x1="12" y1="9" x2="12" y2="15" />
            <line x1="9" y1="12" x2="15" y2="12" />
          </svg>
        ),
        path: "/Dashboard/DeliveryFare"
      },
      {
        name: "Platform Fee",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 1v22m11-11H1" />
            <path d="M4.22 4.22l12.56 12.56m0-12.56L4.22 16.78" />
          </svg>
        ),
        path: "/Dashboard/PlatformFee"
      },
      {
        name: "Application Pages",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="8" y1="13" x2="16" y2="13" />
            <line x1="8" y1="17" x2="16" y2="17" />
          </svg>
        ),
        path: "/Dashboard/MOUAgreements"
      },
      // {
      //   name: "App PrivacyPolicy",
      //   icon: (
      //     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      //       <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      //       <path d="M12 12v-2" />
      //       <path d="M12 16v-2" />
      //     </svg>
      //   ),
      //   path: "/Dashboard/ApplicationPolicy"
      // },
      // {
      //   name: "App Terms Conditions",
      //   icon: (
      //     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      //       <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      //       <polyline points="14 2 14 8 20 8" />
      //       <line x1="9" y1="13" x2="15" y2="13" />
      //       <line x1="9" y1="17" x2="15" y2="17" />
      //       <line x1="9" y1="9" x2="10" y2="9" />
      //     </svg>
      //   ),
      //   path: "/Dashboard/ApplicationTerms"
      // },
      // {
      //   name: "App CancellationPolicy",
      //   icon: (
      //     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      //       <line x1="5" y1="12" x2="19" y2="12" />
      //       <path d="M9 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
      //       <line x1="10" y1="6" x2="14" y2="6" />
      //     </svg>
      //   ),
      //   path: "/Dashboard/appCancellationPolicy"
      // }
    ]
  },
  {
    section: "WEBSITE",
    items: [
      {
        name: "Website",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M2 12h20" />
            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
          </svg>
        ),
        path: "/Dashboard/Website"
      },
    
     
      {
        name: "Pages",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
            <line x1="8" y1="8" x2="16" y2="8" />
            <line x1="8" y1="12" x2="16" y2="12" />
            <line x1="8" y1="16" x2="12" y2="16" />
          </svg>
        ),
        path: "/Dashboard/pages"
      },
      {
        name: "Privacy Policy",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
        ),
        path: "/Dashboard/CMSPages"
      },
      {
        name: "Terms & Conditions",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="9" y1="13" x2="15" y2="13" />
            <line x1="9" y1="17" x2="15" y2="17" />
          </svg>
        ),
        path: "/Dashboard/TermsAndConditions"
      },
      {
        name: "About us",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="1" />
            <path d="M12 1v6m0 6v6" />
            <path d="M4.22 4.22l4.24 4.24m5.08 0l4.24-4.24" />
            <path d="M19.78 4.22l-4.24 4.24m-5.08 0l-4.24-4.24" />
          </svg>
        ),
        path: "/Dashboard/aboutus"
      },
      {
        name: "Cancellation policy",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="3 6 5 4 21 4 23 6" />
            <line x1="3" y1="6" x2="5" y2="20" />
            <line x1="19" y1="6" x2="21" y2="20" />
            <line x1="5" y1="4" x2="19" y2="4" />
            <line x1="10" y1="9" x2="10" y2="17" />
            <line x1="14" y1="9" x2="14" y2="17" />
          </svg>
        ),
        path: "/Dashboard/Cancellationpolicyages"
      },
      {
        name: "Refund policy",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
            <path d="M21 3v5h-5" />
            <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
            <path d="M3 21v-5h5" />
          </svg>
        ),
        path: "/Dashboard/Refundpolicy"
      },
      {
        name: "Services",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 11h8V3H3z" />
            <path d="M13 11h8V3h-8z" />
            <path d="M3 21h8v-8H3z" />
            <path d="M13 21h8v-8h-8z" />
          </svg>
        ),
        path: "/Dashboard/servicesA"
      },
      {
        name: "Choose Us",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
        ),
        path: "/Dashboard/ChooseUs"
      },
      {
        name: "Press Release",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="3" width="20" height="14" rx="2" />
            <line x1="2" y1="9" x2="22" y2="9" />
            <line x1="2" y1="15" x2="11" y2="15" />
          </svg>
        ),
        path: "/Dashboard/PressRelease"
      },
      {
        name: "Enquiries",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
        ),
        path: "/Dashboard/enquiries"
      },
      {
        name: "Footer Certificates",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <path d="M12 9h.01" />
            <path d="M11 14h2" />
            <path d="M9 19h6" />
          </svg>
        ),
        path: "/Dashboard/footercertificates"
      },
      {
        name: "WebSetting",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <path d="M12 9h.01" />
            <path d="M11 14h2" />
            <path d="M9 19h6" />
          </svg>
        ),
        path: "/Dashboard/WebContentManager"
      }
    ]
  },
  {
    section: "DEV FEEDBACK",
    items: [
      {
        name: "Rating&Review",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
        ),
        path: "/Dashboard/RatingReview"
      },
      {
        name: "Dev Feedback",
        icon: (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            <circle cx="9" cy="10" r="1" />
            <circle cx="12" cy="10" r="1" />
            <circle cx="15" cy="10" r="1" />
          </svg>
        ),
        path: "/Dashboard/devfeedback"
      }
    ]
  }
];

// ─────────────────────────────────────────────────────────────────────────────
// ICONS FOR SIDEBAR
// ─────────────────────────────────────────────────────────────────────────────
const SunIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="5" />
    <line x1="12" y1="1" x2="12" y2="3" />
    <line x1="12" y1="21" x2="12" y2="23" />
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
    <line x1="1" y1="12" x2="3" y2="12" />
    <line x1="21" y1="12" x2="23" y2="12" />
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
  </svg>
);

const MoonIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

const CollapseIcon = ({ collapsed }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{
    transition: "transform 0.3s ease",
    transform: collapsed ? "rotate(180deg)" : "rotate(0deg)",
  }}>
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const NotificationIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

const ProfileIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const styles = {
  dark: {
    sidebar: { background: "#1a1f2e", border: "1px solid rgba(255,255,255,0.06)" },
    logo: { color: "#fff" },
    logoAccent: { color: "#6c63ff" },
    section: { color: "#4a5568" },
    item: { color: "#94a3b8" },
    itemHover: { background: "rgba(108,99,255,0.12)", color: "#fff" },
    itemActive: { background: "rgba(108,99,255,0.2)", color: "#a89fff" },
    activeBar: { background: "#6c63ff" },
    sub: { color: "#64748b" },
    subHover: { color: "#94a3b8" },
    subActive: { color: "#a89fff" },
    subDot: { background: "#6c63ff" },
    toggle: { background: "rgba(255,255,255,0.07)", color: "#94a3b8" },
    toggleHover: { background: "rgba(255,255,255,0.12)" },
    collapseBtn: { background: "#252c3d", border: "1px solid rgba(255,255,255,0.08)", color: "#94a3b8" },
    actionBtnHover: { background: "rgba(255,255,255,0.08)" },
  },
  light: {
    sidebar: { background: "#ffffff", border: "1px solid #e8ecf4" },
    logo: { color: "#1e293b" },
    logoAccent: { color: "#6c63ff" },
    section: { color: "#94a3b8" },
    item: { color: "#475569" },
    itemHover: { background: "rgba(108,99,255,0.08)", color: "#1e293b" },
    itemActive: { background: "rgba(108,99,255,0.1)", color: "#6c63ff" },
    activeBar: { background: "#6c63ff" },
    sub: { color: "#94a3b8" },
    subHover: { color: "#475569" },
    subActive: { color: "#6c63ff" },
    subDot: { background: "#6c63ff" },
    toggle: { background: "#f1f5f9", color: "#64748b" },
    toggleHover: { background: "#e2e8f0" },
    collapseBtn: { background: "#f8fafc", border: "1px solid #e2e8f0", color: "#64748b" },
    actionBtnHover: { background: "rgba(0,0,0,0.05)" },
  },
};

const Sidebar = ({
  activeItem = "Dashboards",
  setActiveItem,
  isSidebarCollapsed = false,
  setIsSidebarCollapsed,
  isDark = true,
  setIsDark,
  onMobileClose,
  notificationCount = 3,
  onNotificationClick,
  onProfileClick,
}) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [hoveredToggle, setHoveredToggle] = useState(false);
  const [hoveredAction, setHoveredAction] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const theme = isDark ? styles.dark : styles.light;

  const handleNavigation = (path, name) => {
    setActiveItem(name);
    if (path) navigate(path);
    if (isMobile && onMobileClose) onMobileClose();
  };

  // ─── Navigation Handlers ───
  const handleNotificationClick = () => {
    navigate("/Dashboard/ShowNotification");
    if (onNotificationClick) onNotificationClick();
    if (isMobile && onMobileClose) onMobileClose();
  };

  const handleProfileClick = () => {
    navigate("/Dashboard/ProfileSettings");
    if (onProfileClick) onProfileClick();
    if (isMobile && onMobileClose) onMobileClose();
  };

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <div
        style={{
          width: isSidebarCollapsed && !isMobile ? "68px" : isMobile ? "260px" : "240px",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          transition: "width 0.3s cubic-bezier(0.4,0,0.2,1)",
          overflow: "hidden",
          position: "relative",
          flexShrink: 0,
          boxShadow: isDark ? "4px 0 24px rgba(0,0,0,0.3)" : "4px 0 24px rgba(0,0,0,0.06)",
          ...theme.sidebar,
        }}
      >
        {/* Logo */}
        <div style={{
          padding: isSidebarCollapsed && !isMobile ? "20px 0" : "20px 20px 16px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          justifyContent: (isSidebarCollapsed && !isMobile) ? "center" : "flex-start",
          borderBottom: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid #f1f5f9",
          marginBottom: "8px",
          flexShrink: 0,
        }}>
          <div style={{ 
            flexShrink: 0,
            width: (isSidebarCollapsed && !isMobile) ? "32px" : "36px",
            height: (isSidebarCollapsed && !isMobile) ? "32px" : "36px",
            borderRadius: "8px",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: isDark ? "#141824" : "#ffffff",
          }}>
            <img 
              src="https://thumbs.dreamstime.com/b/initial-letter-zd-logotype-company-name-colored-blue-grey-swoosh-design-vector-logo-business-company-identity-initial-199364284.jpg"
              alt="Logo"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Crect width='40' height='40' fill='%236c63ff'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='white' font-size='20' font-weight='bold'%3EZD%3C/text%3E%3C/svg%3E";
              }}
            />
          </div>
          {(!isSidebarCollapsed || isMobile) && (
            <span style={{ fontFamily: "'Segoe UI', sans-serif", fontWeight: 700, fontSize: "18px", letterSpacing: "-0.3px", ...theme.logo }}>
              Admin<span style={theme.logoAccent}>Panel</span>
            </span>
          )}
        </div>

        {/* Scrollable menu */}
        <div style={{
          flex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          paddingBottom: "12px",
          scrollbarWidth: "thin",
        }}>
          {menuData.map((group) => (
            <div key={group.section} style={{ marginBottom: "4px" }}>
              {(!isSidebarCollapsed || isMobile) && (
                <div style={{ padding: "12px 20px 4px", fontSize: "10px", fontWeight: 700, letterSpacing: "1.2px", textTransform: "uppercase", ...theme.section }}>
                  {group.section}
                </div>
              )}
              {(isSidebarCollapsed && !isMobile) && <div style={{ height: "8px" }} />}

              {group.items.map((item) => {
                const active = activeItem === item.name;
                const hovered = hoveredItem === item.name;

                return (
                  <div key={item.name}>
                    <div
                      onClick={() => handleNavigation(item.path, item.name)}
                      onMouseEnter={() => setHoveredItem(item.name)}
                      onMouseLeave={() => setHoveredItem(null)}
                      title={(isSidebarCollapsed && !isMobile) ? item.name : ""}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        padding: (isSidebarCollapsed && !isMobile) ? "10px 0" : "9px 20px",
                        justifyContent: (isSidebarCollapsed && !isMobile) ? "center" : "flex-start",
                        cursor: "pointer",
                        position: "relative",
                        borderRadius: (isSidebarCollapsed && !isMobile) ? "0" : "0 8px 8px 0",
                        margin: (isSidebarCollapsed && !isMobile) ? "2px 0" : "1px 10px 1px 0",
                        transition: "all 0.15s ease",
                        ...(active ? theme.itemActive : hovered ? theme.itemHover : { color: theme.item.color }),
                      }}
                    >
                      {active && (
                        <div style={{ position: "absolute", left: 0, top: "50%", transform: "translateY(-50%)", width: "3px", height: "60%", borderRadius: "0 3px 3px 0", ...theme.activeBar }} />
                      )}
                      <span style={{ flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        {item.icon}
                      </span>
                      {(!isSidebarCollapsed || isMobile) && (
                        <span style={{ flex: 1, fontSize: "13.5px", fontWeight: active ? 600 : 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {item.name}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>

        {/* Bottom controls - Theme Toggle + Notification + Profile */}
        <div style={{
          padding: (isSidebarCollapsed && !isMobile) ? "12px 0" : "12px 16px",
          borderTop: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid #f1f5f9",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          justifyContent: (isSidebarCollapsed && !isMobile) ? "center" : "space-between",
          flexShrink: 0,
        }}>
          {/* Theme Toggle */}
          <button
            onClick={() => setIsDark(!isDark)}
            onMouseEnter={() => setHoveredToggle(true)}
            onMouseLeave={() => setHoveredToggle(false)}
            title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              padding: (isSidebarCollapsed && !isMobile) ? "7px" : "7px 12px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              fontSize: "12px",
              fontWeight: 500,
              transition: "all 0.15s ease",
              ...(hoveredToggle ? theme.toggleHover : theme.toggle),
            }}
          >
            {isDark ? <SunIcon /> : <MoonIcon />}
            {(!isSidebarCollapsed || isMobile) && (
              <span>{isDark ? "Light" : "Dark"}</span>
            )}
          </button>

          {/* Action Buttons - Notification & Profile */}
          {(!isSidebarCollapsed || isMobile) && (
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "2px",
            }}>
              {/* Notification Button - Navigates to Notification page */}
              <button
                onClick={handleNotificationClick}
                onMouseEnter={() => setHoveredAction("notification")}
                onMouseLeave={() => setHoveredAction(null)}
                title="Notifications"
                style={{
                  position: "relative",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: "6px",
                  borderRadius: "8px",
                  color: isDark ? "#94a3b8" : "#64748b",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.15s ease",
                  ...(hoveredAction === "notification" ? theme.actionBtnHover : {}),
                }}
              >
                <NotificationIcon />
                {(notificationCount || 0) > 0 && (
                  <span style={{
                    position: "absolute",
                    top: "0px",
                    right: "0px",
                    background: "#ef4444",
                    color: "#fff",
                    fontSize: "8px",
                    fontWeight: 700,
                    width: "16px",
                    height: "16px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: isDark ? "2px solid #1a1f2e" : "2px solid #ffffff",
                  }}>
                    {(notificationCount || 0) > 9 ? "9+" : notificationCount}
                  </span>
                )}
              </button>

              {/* Profile Button - Navigates to Profile Settings page */}
              <button
                onClick={handleProfileClick}
                onMouseEnter={() => setHoveredAction("profile")}
                onMouseLeave={() => setHoveredAction(null)}
                title="Profile Settings"
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: "6px",
                  borderRadius: "8px",
                  color: isDark ? "#94a3b8" : "#64748b",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.15s ease",
                  ...(hoveredAction === "profile" ? theme.actionBtnHover : {}),
                }}
              >
                <ProfileIcon />
              </button>
            </div>
          )}

          {/* Collapse Button */}
          {!isMobile && (
            !isSidebarCollapsed ? (
              <button onClick={() => setIsSidebarCollapsed(true)} title="Collapse Sidebar" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "28px", height: "28px", borderRadius: "8px", cursor: "pointer", transition: "all 0.15s ease", ...theme.collapseBtn }}>
                <CollapseIcon collapsed={false} />
              </button>
            ) : (
              <button onClick={() => setIsSidebarCollapsed(false)} title="Expand Sidebar" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "28px", height: "28px", borderRadius: "8px", cursor: "pointer", transition: "all 0.15s ease", ...theme.collapseBtn }}>
                <CollapseIcon collapsed={true} />
              </button>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;